import axios from "../../api/axiosApi";
import {createAsyncThunk} from "@reduxjs/toolkit";

const getErrorMessage = (e) => {
    if (!e.response) {
        return 'Network error. Please check your connection and try again.';
    }
    if (e.response.status === 401) {
        return 'Your session is no longer valid. Please log in again.';
    }
    return e.response.data?.error || `Something went wrong (error ${e.response.status}).`;
};

export const fetchPaintings = createAsyncThunk(
    'paintings/fetch',
    async () => await axios.get('/paintings').then(res => res.data)
);

export const createPainting = createAsyncThunk(
    'paintings/create',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post('/paintings', data);
            return response.data;
        } catch (e) {
            return rejectWithValue(getErrorMessage(e));
        }
    }
);

export const updatePainting = createAsyncThunk(
    'paintings/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.patch(`/paintings/${id}`, data);
            return response.data;
        } catch (e) {
            return rejectWithValue(getErrorMessage(e));
        }
    }
);

export const deletePainting = createAsyncThunk(
    'paintings/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`/paintings/${id}`);
            return response.data;
        } catch (e) {
            return rejectWithValue(getErrorMessage(e));
        }
    }
);

export const moveToSold = createAsyncThunk(
    'paintings/moveToSold',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.patch(`/paintings/${id}/move-to-sold`);
            return response.data;
        } catch (e) {
            return rejectWithValue(getErrorMessage(e));
        }
    }
);

export const moveToAvailable = createAsyncThunk(
    'paintings/moveToAvailable',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.patch(`/paintings/${id}/move-to-available`);
            return response.data;
        } catch (e) {
            return rejectWithValue(getErrorMessage(e));
        }
    }
);